var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "n5lvnzl2ja"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.725490 0 0 0 0 0.737255 0 0 0 0 0.745098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#n5lvnzl2ja)",
    transform: "translate(-179 -137) translate(168 127)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#E36510",
    strokeWidth: 2,
    d: "M55.111 40.445c0 8.1-6.567 14.666-14.667 14.666s-14.666-6.567-14.666-14.666c0-8.1 6.566-14.667 14.666-14.667 8.1 0 14.667 6.566 14.667 14.667zM45.333 18.667L34.667 18.667 40 8zM34.667 61.333L45.333 61.333 39.999 72zM59.732 28.444L52.444 21.156 63.111 17.778zM21.158 52.444L28.444 59.733 17.778 63.111zM61.333 45.333L61.333 34.667 72 40.001zM18.667 34.667L18.667 45.333 8 40zM52.444 59.732L59.733 52.444 63.111 63.111zM28.444 21.157L21.157 28.444 17.778 17.778z",
    transform: "translate(11 10)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherTempIcon);
export default __webpack_public_path__ + "static/media/weather-temp-icon.d91bcafb1cae50edc88d96b0fc2efa5f.svg";
export { ForwardRef as ReactComponent };